<template>
    <b-card header-tag="header" class="m-3" no-body>
        <template #header>
            <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
                Questionários IEGM
            </h6>
        </template>
        <b-card-text>
            <b-list-group class="m-3 text-left" v-if="items && !isLoading">
                <b-list-group-item v-for="item in items" :key="item.Id" :href="item.UrlQuestionario" target="_blank">
                    <font-awesome-icon :icon="item.icon" class="mx-3" />
                    <span>{{ item.Questionario }}</span>
                </b-list-group-item>
            </b-list-group>
            <b-alert v-if="!items.length && !isLoading" variant="info" show class="mx-3">
                Nenhum questionário disponível
            </b-alert>
        </b-card-text>
    </b-card>
</template>

<script lang="ts">
import questionarioService from "@/services/entregas/questionarioService";
import { store } from "@/store"
import { QuestionarioIegm } from "@/types/questionarios/questionario-iegm";
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';

const CompProps = Vue.extend({
    name: 'LinksIegm',
    components: {}
})

@Component
export default class ConsultarLDI extends mixins(UtilsTS, CompProps) {
    items: QuestionarioIegm[] = [];
    isLoading = false;

    mounted() {
        this.fetchData();
    }

    async fetchData(): Promise<void> {
        try {
            store.blockScreen = true
            this.isLoading = true
            this.items = await questionarioService.getQuestionariosIegm();
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            store.blockScreen = false
            this.isLoading = false
        }
    }
}
</script>